import Vue from 'vue'
import store from '@/store'
import Router from 'vue-router'
import routes from './routes'
import localforage from 'localforage'

Vue.use(Router)

const router = new Router({
  routes,
  base: process.env.BASE_URL,
  mode: 'history'
})

const checkAuth = async (to, from, next) => {
  const currentUser = await localforage.getItem('currentUser')
  store.dispatch('auth/setUser', currentUser)

  if (to.name !== 'login_path' && currentUser === null) {
    next({
      name: 'login_path',
      query: {
        redirectTo: to.fullPath
      }
    })
  }
}

router.beforeEach((to, from, next) => {
  console.log(`🚦 navigating to ${to.name} from ${from.name}`)
  checkAuth(to, from, next)
  next()
})

export default router
